<template>
<div class="MilestoneOverlayDiv">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row margin-left-1Point5Perc">
                <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc create-element-overlay-course-title-font-styles">
                  {{getCurrentSelectedGroupObj.GroupName}}
                </div>    
                <div class="col-md-5 col-lg-5">
                  <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="closeMileStoneActionOverlay">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row margin-left-1Point5Perc padding-bottom-1Perc bottom-border margin-bottom-2Perc">
                <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles">
                  {{getCurrSelectedMilestoneObjFromList.Title}}
                </div>    
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                  <div class="col-md-4 col-lg-4">
                  </div>  
                  <div class="col-md-4 col-lg-4 text-align-center">
                    <button type="button" class="btn gray-border white-BG" v-on:click="updateCreateMilestoneActionDropDownFlag">+ Create New Action</button>
                  </div>
                  <div class="col-md-4 col-lg-4">
                  </div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="showCreateMilestoneActionDropDownUI">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Action Type
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" v-model="getSelectedMilestoneActionValue">
                        <option value=-1 disabled>Select</option>
                        <option v-for="value in getMilestoneActions" v-bind:key="value" v-bind:value="value"> {{getMilestoneActionNameUsingActionId(value)}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <!-- AK: Start of For showing bottom border -->
              <div class="row margin-bottom-2Perc" v-if="showCreateMilestoneActionDropDownUI">
                  <div class="col-md-1 col-lg-1"></div>
                  <div class="col-md-10 col-lg-10 grey-bottom-border"></div>
                  <div class="row col-md-1 col-lg-1"></div>
              </div>
              <!-- End of For showing bottom border -->
              <div class="table-responsive margin-Top-6Perc overflow-x-hidden margin-bottom-2Perc" v-if="getExistingMilestoneActionList.length > 0 && !showingCreateOrUpdateOverlay">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th class="text-align-center font-size-15px border-right">Milestone Type</th>
                      <th class="text-align-center font-size-15px border-right">Action Type</th>
                      <th class="text-align-center font-size-15px border-right">Action Title</th>
                      <th class="text-align-center font-size-15px">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="existingMilestoneActionObj in getExistingMilestoneActionList" :key="existingMilestoneActionObj.MilestoneActionId" :existingMilestoneActionObj="existingMilestoneActionObj" >
                      <td class="border-right">{{getMilestoneNameUsingMilestoneId(getCurrSelectedMilestoneObjFromList)}}</td>
                      <td class="border-right">{{getMilestoneActionNameUsingActionId(existingMilestoneActionObj.Type)}}</td>
                      <td class="border-right">{{existingMilestoneActionObj.Title}}</td>
                      <td>
                        <a class="cursor-pointer" @click="performClickOperation($event,'update', existingMilestoneActionObj)"> Edit  </a>|
                        <a class="cursor-pointer" @click="performClickOperation($event,'delete', existingMilestoneActionObj)"> Delete</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row margin-bottom-2Perc" v-else>
                <div class="col-sm-12">
                  <span class="opacity font-weight-bold">No Milestone Action(s) were found for <i>"{{getCurrSelectedMilestoneObjFromList.Title}}"</i> milestone.</span> 
                </div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="closeMileStoneActionOverlay">Done</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <create-allow-specified-course-type-milestone-action-overlay v-if="showCreateAllowSpecifiedCourseTypeMilestoneActionOverlay" :selectedGroupObj="getCurrentSelectedGroupObj" :selectedMilestoneActionObj="getSelectedMilestoneActionValue" :currSelectedExistingMilestoneObjFromList="getCurrSelectedMilestoneObjFromList" @closeOverlay="handleCloseOverlay"></create-allow-specified-course-type-milestone-action-overlay>
      <update-allow-specified-course-type-milestone-action-overlay v-if="showUpdateAllowSpecifiedCourseTypeMilestoneActionOverlay" :selectedGroupObj="getCurrentSelectedGroupObj" :currSelectedExistingMilestoneObjFromList="getCurrSelectedMilestoneObjFromList" :existingSelectedMilestoneActionObj="getExistingSelectedMilestoneActionObj" @closeOverlay="handleCloseOverlay"></update-allow-specified-course-type-milestone-action-overlay>
      <create-allow-all-electives-type-milestone-action-overlay v-if="showCreateAllowAllElectivesTypeMilestoneActionOverlay" :selectedGroupObj="getCurrentSelectedGroupObj" :selectedMilestoneActionObj="getSelectedMilestoneActionValue" :currSelectedExistingMilestoneObjFromList="getCurrSelectedMilestoneObjFromList" @closeOverlay="handleCloseOverlay"></create-allow-all-electives-type-milestone-action-overlay>
      <update-allow-all-electives-type-milestone-action-overlay v-if="showUpdateAllowAllElectivesTypeMilestoneActionOverlay" :selectedGroupObj="getCurrentSelectedGroupObj" :currSelectedExistingMilestoneObjFromList="getCurrSelectedMilestoneObjFromList" :existingSelectedMilestoneActionObj="getExistingSelectedMilestoneActionObj" @closeOverlay="handleCloseOverlay"></update-allow-all-electives-type-milestone-action-overlay>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteMilestoneActionString" v-bind:postfixString="postDeleteMilestoneActionString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="peformConfirmationAlertClickAction"></confirmation-alert>
 </div>
 </div>
</template>

<script>
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { milestoneService } from '@/server-util/milestone-service'
import CreateAllowSpecifiedCourseTypeMilestoneActionOverlay from '@/components/CreateAllowSpecifiedCourseTypeMilestoneActionOverlay'
import UpdateAllowSpecifiedCourseTypeMilestoneActionOverlay from '@/components/UpdateAllowSpecifiedCourseTypeMilestoneActionOverlay'
import CreateAllowAllElectivesTypeMilestoneActionOverlay from '@/components/CreateAllowAllElectivesTypeMilestoneActionOverlay'
import UpdateAllowAllElectivesTypeMilestoneActionOverlay from '@/components/UpdateAllowAllElectivesTypeMilestoneActionOverlay'
import filter from 'lodash/filter'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
export default {
  props: ['selectedGroupObj', 'currSelectedMilestoneObjFromList'],
  created: function () {
    this.getPreviouslyCreatedMilestoneActions(true)
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      selectedMilestoneActionObj: -1,
      showCreateAllowSpecifiedCourseTypeMilestoneActionOverlay: false,
      showUpdateAllowSpecifiedCourseTypeMilestoneActionOverlay: false,
      showCreateAllowAllElectivesTypeMilestoneActionOverlay: false,
      showUpdateAllowAllElectivesTypeMilestoneActionOverlay: false,
      existingMilestoneActionList: [],
      showCreateMilestoneActionDropDownUI: false,
      currSelectedExistingMilestoneActionObjFromList: null,
      showingCreateOrUpdateOverlay: false,
      showConfirmationBox: false,
      prefixDeleteMilestoneActionString: '',
      postDeleteMilestoneActionString: ''
    }
  },
  name: 'MilestoneOverlayDiv',
  methods: {
    peformConfirmationAlertClickAction (value) {
      this.showConfirmationBox = false
      if (value) {
        this.deleteMilestoneAction()
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
    },
    getMilestoneNameUsingMilestoneId: function (milestoneObj) {
      var currMileStoneObj = filter(this.getMilestoneList, function (o) {
        return o.MilestoneInfoId === milestoneObj.MilestoneInfoId
      })
      if (currMileStoneObj !== undefined && currMileStoneObj !== null && currMileStoneObj !== 'null' && currMileStoneObj.length !== 0) {
        return currMileStoneObj[0].Title
      } else {
        return ''
      }
    },
    getMilestoneActionNameUsingActionId: function (currMilestoneActionType) {
      var strToReturn = ''
      switch (currMilestoneActionType) {
        case constants.MilestoneActionType.Allow_Specified_Courses:
          strToReturn = 'Allow Specified Course'
          break
        case constants.MilestoneActionType.Allow_All_Electives:
          strToReturn = 'Allow All Electives'
          break
      }
      return strToReturn
    },
    getMilestoneTypeUsingMilestoneId: function (milestoneObj) {
      var currMileStoneObj = filter(this.getMilestoneList, function (o) {
        return o.MilestoneInfoId === milestoneObj.MilestoneInfoId
      })
      if (currMileStoneObj !== undefined && currMileStoneObj !== null && currMileStoneObj !== 'null' && currMileStoneObj.length !== 0) {
        return currMileStoneObj[0].Type
      } else {
        return null
      }
    },
    performClickOperation: function (event, selectedOperation, selectedMilestoneObj) {
      this.currSelectedExistingMilestoneActionObjFromList = selectedMilestoneObj
      switch (selectedOperation) {
        case 'update':
          this.checkAndRenderRespectiveUpdateMilestoneActionUI()
          break
        case 'delete':
          this.showConfirmationBox = true
          this.prefixDeleteMilestoneActionString = 'Are you sure you want to delete '
          this.postDeleteMilestoneActionString = '\'' + this.currSelectedExistingMilestoneActionObjFromList.Title + '\' milestone action?'
          break
      }
    },
    updateCreateMilestoneActionDropDownFlag: function () {
      this.showCreateMilestoneActionDropDownUI = !this.showCreateMilestoneActionDropDownUI
      // AK: Reset previously selected milestone action type to initial value if user revisited it
      if (this.showCreateMilestoneActionDropDownUI) {
        this.selectedMilestoneActionObj = -1
      }
    },
    handleCloseOverlay (value) {
      const hasMilestoneActionCreatedOrUpdated = value.hasMilestoneActionCreatedOrUpdated
      const closeOverlay = value.closeOverlay
      const overlayType = value.type
      /*
        AK: Update gobal flag showingCreateOrUpdateOverlay to false for showing table list again.
        Since we are not closing current milestone listing overlay while opening create/update milestone
        pop-up hence doing such way.
      */
      this.showingCreateOrUpdateOverlay = false
      this.showCreateMilestoneActionDropDownUI = false
      switch (overlayType) {
        case 'create':
          this.selectedMilestoneActionObj = -1
          this.showCreateAllowSpecifiedCourseTypeMilestoneActionOverlay = closeOverlay
          this.showCreateAllowAllElectivesTypeMilestoneActionOverlay = closeOverlay
          break
        case 'update':
          this.showUpdateAllowSpecifiedCourseTypeMilestoneActionOverlay = closeOverlay
          this.showUpdateAllowAllElectivesTypeMilestoneActionOverlay = closeOverlay
          break
        default:
          this.showCreateAllowSpecifiedCourseTypeMilestoneActionOverlay = closeOverlay
          this.showUpdateAllowSpecifiedCourseTypeMilestoneActionOverlay = closeOverlay
          this.showCreateAllowAllElectivesTypeMilestoneActionOverlay = closeOverlay
          this.showUpdateAllowAllElectivesTypeMilestoneActionOverlay = closeOverlay
          break
      }
      if (hasMilestoneActionCreatedOrUpdated) {
        this.getPreviouslyCreatedMilestoneActions(false)
      }
    },
    closeMileStoneActionOverlay: function () {
      var obj = {
        closeOverlay: false,
        type: 'action'
      }
      this.$emit('closeOverlay', obj)
    },
    deleteMilestoneAction () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== '' && storeObj.state.access_token !== null) {
        var _this = this
        _this.$store.state.isLoading = true
        milestoneService
          .deleteMilestoneAction(
            storeObj.state.access_token,
            this.currSelectedExistingMilestoneActionObjFromList.MilestoneActionId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.getPreviouslyCreatedMilestoneActions(false)
            } else {
              if (_this.$store.state.isLoading) {
                _this.$store.state.isLoading = false
              }
              _this.showAlertDialog = true
              _this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            if (_this.$store.state.isLoading) {
              _this.$store.state.isLoading = false
            }
            _this.showAlertDialog = true
            if (errorObj.response === undefined) {
              _this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              _this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log('FOUND EMPTY ACCESS TOKEN HENCE DECLINED DELETE MILESTONE OPERATION.')
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.getSelectedMilestoneActionValue === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a Milestone action to create.'
        return false
      }
      return true
    },
    getPreviouslyCreatedMilestoneActions: function (isComingFromOnCreate = false) {
      var storeObj = this.$store
      var _this = this
      _this.$store.state.isLoading = true
      if (
        this.getCurrSelectedMilestoneObjFromList !== undefined &&
        this.getCurrSelectedMilestoneObjFromList !== null &&
        this.getCurrSelectedMilestoneObjFromList !== 'null'
      ) {
        milestoneService
          .getMilestoneActionList(storeObj.state.access_token, this.getCurrSelectedMilestoneObjFromList.MilestoneId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.existingMilestoneActionList = responseObj.data
              // AK: Hide Spinner after recieving updated milestone action list
              _this.$store.state.isLoading = false
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'MILESTONE OBJECT IS NULL HENCE DECLINED LOADING EXISTING MILESTONE ACTION LIST OPERATION'
        )
      }
    },
    checkAndRenderRespectiveCreateMilestoneActionUI: function () {
      // AK: Update gobal flag showingCreateOrUpdateOverlay to true for hiding table list
      this.showingCreateOrUpdateOverlay = true
      const currSelectedMilestoneType = this.getSelectedMilestoneActionValue
      switch (currSelectedMilestoneType) {
        case constants.MilestoneActionType.Allow_Specified_Courses:
          this.showCreateAllowSpecifiedCourseTypeMilestoneActionOverlay = true
          break
        case constants.MilestoneActionType.Allow_All_Electives:
          this.showCreateAllowAllElectivesTypeMilestoneActionOverlay = true
          break
      }
    },
    checkAndRenderRespectiveUpdateMilestoneActionUI: function () {
      // AK: Update gobal flag showingCreateOrUpdateOverlay to true for hiding table list
      this.showingCreateOrUpdateOverlay = true
      const currSelectedMilestoneType = this.currSelectedExistingMilestoneActionObjFromList.Type
      switch (currSelectedMilestoneType) {
        case constants.MilestoneActionType.Allow_Specified_Courses:
          this.showUpdateAllowSpecifiedCourseTypeMilestoneActionOverlay = true
          break
        case constants.MilestoneActionType.Allow_All_Electives:
          this.showUpdateAllowAllElectivesTypeMilestoneActionOverlay = true
          break
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'create-allow-specified-course-type-milestone-action-overlay': CreateAllowSpecifiedCourseTypeMilestoneActionOverlay,
    'update-allow-specified-course-type-milestone-action-overlay': UpdateAllowSpecifiedCourseTypeMilestoneActionOverlay,
    'create-allow-all-electives-type-milestone-action-overlay': CreateAllowAllElectivesTypeMilestoneActionOverlay,
    'update-allow-all-electives-type-milestone-action-overlay': UpdateAllowAllElectivesTypeMilestoneActionOverlay,
    'confirmation-alert': ConfirmationOverlay
  },
  computed: {
    getCurrentSelectedGroupObj: {
      get: function () {
        return this.selectedGroupObj
      }
    },
    getCurrSelectedMilestoneObjFromList: {
      get: function () {
        return this.currSelectedMilestoneObjFromList
      }
    },
    getMilestoneList: {
      get: function () {
        return this.$store.state.milestoneInfoList
      }
    },
    getMilestoneActions: {
      get: function () {
        return constants.MilestoneActionType
      }
    },
    getSelectedMilestoneActionValue: {
      get: function () {
        return this.selectedMilestoneActionObj
      },
      set: function (newValue) {
        this.selectedMilestoneActionObj = newValue
        if (newValue !== -1) {
          this.checkAndRenderRespectiveCreateMilestoneActionUI()
        }
      }
    },
    getExistingMilestoneActionList: {
      get: function () {
        return this.existingMilestoneActionList
      },
      set: function (newValue) {
        this.existingMilestoneActionList = newValue
      }
    },
    getExistingSelectedMilestoneActionObj: {
      get: function () {
        return this.currSelectedExistingMilestoneActionObjFromList
      }
    }
  },
  watch: {}
}
</script>

<style scoped>
.MilestoneOverlayDiv {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

.overflow-x-hidden{
  overflow-x: hidden !important;
}
.font-size-18px {
font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 20%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.float-right {
  float: right;
}

.grey-bottom-border {
  border-bottom: 1px solid #dddddd;
}

.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
  border: 1px solid red;
}
.font-weight-bold {
  font-weight: 700;
}
.opacity {
  opacity: 0.75;
}
.margin-top-1-perc {
  margin-top: 1%;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.border-right
{
  border-right: 1px solid #aaa !important;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.font-wight-bold {
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/MilestoneActionOverlay.vue